import ModelEditDto from 'app/admin/model/dto/ModelEditDto';
import ExpressionModelInputAttributeEditDto from './ExpressionModelInputAttributeEditDto';
import ExpressionModelOutputAttributeEditDto from './ExpressionModelOutputAttributeEditDto';

export class ExpressionModelEditDto extends ModelEditDto {
	constructor() {
		super();
		/** @type {ExpressionModelInputAttributeEditDto[]} */
		this.inputAttributes = null;
		/** @type {ExpressionModelOutputAttributeEditDto[]} */
		this.outputAttributes = null;
		/** @type {string} */
		this.state_file = null;
	}

	/**
	 * @typedef {Object} _ExpressionModelEditDtoProps
	 * @property {ExpressionModelInputAttributeEditDto[]} inputAttributes
	 * @property {ExpressionModelOutputAttributeEditDto[]} outputAttributes
	 * @property {string} state_file
	 *
	 * @typedef {import("app/admin/model/dto/ModelEditDto").ModelEditDtoProps & _ExpressionModelEditDtoProps} ExpressionModelEditDtoProps
	 */
	/**
	 *
	 * @param {ExpressionModelEditDtoProps} props
	 * @returns {ExpressionModelEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.inputAttributes = props.inputAttributes !== null ? props.inputAttributes.map(d => new ExpressionModelInputAttributeEditDto().setup(d)) : [];
		this.outputAttributes = props.outputAttributes !== null ? props.outputAttributes.map(d => new ExpressionModelOutputAttributeEditDto().setup(d)) : [];
		this.state_file = props.state_file;
		return this;
	}
}

export default ExpressionModelEditDto;
